/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CalculatePriceRequestDto } from '../models';
// @ts-ignore
import type { CalculatePriceResponseDto } from '../models';
/**
 * SUBSCRIBEApi - axios parameter creator
 * @export
 */
export const SUBSCRIBEApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Расчет стоимости тарифа
         * @param {CalculatePriceRequestDto} calculatePriceRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeControllerCalculatePrice: async (calculatePriceRequestDto: CalculatePriceRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculatePriceRequestDto' is not null or undefined
            assertParamExists('subscribeControllerCalculatePrice', 'calculatePriceRequestDto', calculatePriceRequestDto)
            const localVarPath = `/subscribe/calculatePrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculatePriceRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SUBSCRIBEApi - functional programming interface
 * @export
 */
export const SUBSCRIBEApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SUBSCRIBEApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Расчет стоимости тарифа
         * @param {CalculatePriceRequestDto} calculatePriceRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeControllerCalculatePrice(calculatePriceRequestDto: CalculatePriceRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculatePriceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeControllerCalculatePrice(calculatePriceRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SUBSCRIBEApi.subscribeControllerCalculatePrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SUBSCRIBEApi - factory interface
 * @export
 */
export const SUBSCRIBEApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SUBSCRIBEApiFp(configuration)
    return {
        /**
         * 
         * @summary Расчет стоимости тарифа
         * @param {CalculatePriceRequestDto} calculatePriceRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeControllerCalculatePrice(calculatePriceRequestDto: CalculatePriceRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CalculatePriceResponseDto> {
            return localVarFp.subscribeControllerCalculatePrice(calculatePriceRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SUBSCRIBEApi - object-oriented interface
 * @export
 * @class SUBSCRIBEApi
 * @extends {BaseAPI}
 */
export class SUBSCRIBEApi extends BaseAPI {
    /**
     * 
     * @summary Расчет стоимости тарифа
     * @param {CalculatePriceRequestDto} calculatePriceRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SUBSCRIBEApi
     */
    public subscribeControllerCalculatePrice(calculatePriceRequestDto: CalculatePriceRequestDto, options?: RawAxiosRequestConfig) {
        return SUBSCRIBEApiFp(this.configuration).subscribeControllerCalculatePrice(calculatePriceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

